export default __webpack_public_path__ + "static/media/whats-icon.4e8208bd.svg";